import Box from '@mui/material/Box';
import React from 'react';

import SidebarContent from './SidebarContent';
import SidebarHeader from './SidebarHeader';

export interface SidebarProps {
  children: JSX.Element | JSX.Element[];
}

const Sidebar = ({ children }: SidebarProps) => {
  let header;
  let content;

  React.Children.forEach(children, (child) => {
    if (!child) return;
    switch (child.type) {
      case SidebarHeader:
        header = child;
        break;
      case SidebarContent:
        content = child;
        break;
      default:
        break;
    }
  });
  return (
    <Box
      display="flex"
      flexDirection="column"
      height="100%"
      gap={1}
      sx={{
        bgcolor: 'background.default',
        borderRight: '1px dashed',
        borderColor: 'grey.700',
      }}
    >
      {header}
      {content}
    </Box>
  );
};

Sidebar.Header = SidebarHeader;
Sidebar.Content = SidebarContent;
export default Sidebar;
